import { useEffect } from 'react'
import { useParams } from '@tanstack/react-router'
import { Header } from 'components/layout/header'
import { Main } from 'components/layout/main'
import { Search } from 'components/search'
import {
  fetchBanner,
  updateBanner,
} from 'store/customBanners/customBannersSlice'
import { useAppDispatch, useAppSelector } from 'store/store'
import { EditCustomBannerForm } from 'ui/components/EditCustomBannerForm'

export const EditCustomBannerPage = () => {
  const dispatch = useAppDispatch()
  const customBannersState = useAppSelector((state) => state.customBanners)
  const { id } = useParams({
    from: '/protected/custom-banner/$id/modifica',
  }) as { id: string }
  useEffect(() => {
    if (id) {
      const bannerId = parseInt(id, 10)
      if (!isNaN(bannerId)) {
        dispatch(fetchBanner(bannerId))
      }
    }
  }, [id, dispatch])

  return (
    <>
      {/* ===== Top Heading ===== */}
      <Header>
        <div className='ml-auto flex items-center space-x-4'>
          <Search />
        </div>
      </Header>

      {/* ===== Main ===== */}
      <Main>
        <div className='mb-2 flex flex-wrap items-center justify-between space-y-2 gap-x-4'>
          <div>
            <h2 className='text-2xl font-bold tracking-tight'>
              Modifica Custom Banner
            </h2>
            <p className='text-muted-foreground'>
              Modifica il custom banner selezionato
            </p>
          </div>
        </div>
        <div className='-mx-4 mt-5 flex-1 overflow-auto px-4 py-1 lg:flex-row lg:space-y-0 lg:space-x-12'>
          <div className='flex flex-col gap-5'>
            <EditCustomBannerForm
              onUpdate={(id, data) => {
                dispatch(updateBanner({ id, data }))
              }}
              banner={customBannersState.banner}
            />
          </div>
        </div>
      </Main>
    </>
  )
}

export default EditCustomBannerPage
